import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { axiosPdf } from '../../helpers/axios';
import { AppContext } from '../../context/AppContext';
import { RouteContext } from '../../context/RouteContext';
import { block, unblock } from '../../helpers/loading';
import { ContentContext } from '../../context/ContentContext';
import Swal from 'sweetalert2';
const drawerWidth = 240;
const navItems = ['Comprobante', 'Carnet', 'Resultados', 'Salir'];

export const NavBarSession = () => {
	const [mobileOpen, setMobileOpen] = React.useState(false);

	const { logout, user } = useContext(AppContext);
	const { convo, setConvocatoria } = useContext(RouteContext);
	const { setItemContent, removeItemContent } = useContext(ContentContext);
	const { carnet } = user;

	const navigate = useNavigate();

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	const reimprimirPdf = async () => {
		block();
		const resp = await axiosPdf('reimprimirPdf', { aspirante_id: user.identidad, idconvocatoria: convo });
		const pdf = new File([resp.data], 'Comprobante.pdf', { type: 'application/pdf' });
		window.open(URL.createObjectURL(pdf), '_blank');
		unblock();
	};

	const handleClickItem = (item) => {
		if (item === 'Comprobante') {
			reimprimirPdf();
			removeItemContent(); //establecer children perfil
			//mandar a traer el Comprobante
		} else if (item === 'Resultados') {
			const resultadoPdf = async () => {
				try {
					block();
					const { data } = await axiosPdf('resultadoPdf', {
						aspirante_id: user.identidad,
						idconvocatoria: convo,
					});

					const pdf = new File([data], 'Resultados.pdf', { type: 'application/pdf' });
					window.open(URL.createObjectURL(pdf), '_blank');

					unblock();
				} catch (error) {
					console.info(error);
					//const data = error.data;
					unblock();
					Swal.fire('', 'No se ha calendarizado la visualización de resultados', 'warning');
				}
			};
			resultadoPdf();
		} else if (item === 'Salir') {
			logout();
			setConvocatoria(0);
			removeItemContent();
			navigate('/auth/singup');
		} else if (item === 'Carnet') {
			if (carnet.calendarizado === true) {
				if (carnet.cargado === true) setItemContent(item); //establecer children
				else {
					Swal.fire('', 'No se encuentran datos cargados para la generación de carnet.', 'warning');
					removeItemContent(); //establecer perfil
				}
			} else {
				removeItemContent(); //establecer perfil
				Swal.fire('', 'No se encuentra calendarizado la impresión de carnet.', 'warning');
			}
		}
	};

	const drawer = (
		<Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
			<Typography variant="h6" sx={{ my: 2 }}>
				UPNFM Admisión
			</Typography>
			<Divider />

			<List>
				{navItems.map((item) => (
					<ListItem key={item}>
						<ListItemButton
							sx={{ textAlign: 'center' }}
							onClick={() => {
								handleClickItem(item);
							}}
						>
							<ListItemText primary={item} />
						</ListItemButton>
					</ListItem>
				))}
			</List>
		</Box>
	);

	return (
		<Box sx={{ display: 'flex' }}>
			<AppBar component="nav">
				<Toolbar>
					<IconButton
						color="inherit"
						aria-label="open drawer"
						edge="start"
						onClick={handleDrawerToggle}
						sx={{ mr: 2, display: { sm: 'none' } }}
					>
						<MenuIcon />
					</IconButton>
					<Typography variant="h6" component="div" sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}>
						UPNFM Admisión
					</Typography>
					<Box sx={{ display: { xs: 'none', sm: 'block' } }}>
						{navItems.map((item) => (
							<Button
								key={item}
								sx={{ color: '#fff' }}
								onClick={() => {
									handleClickItem(item);
								}}
							>
								{item}
							</Button>
						))}
					</Box>
				</Toolbar>
			</AppBar>
			<Box component="nav">
				<Drawer
					variant="temporary"
					open={mobileOpen}
					onClose={handleDrawerToggle}
					ModalProps={{
						keepMounted: true,
					}}
					sx={{
						display: { xs: 'block', sm: 'none' },
						'& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
					}}
				>
					{drawer}
				</Drawer>
			</Box>
		</Box>
	);
};
